import { Component, OnInit } from '@angular/core';
import { DxDataGridTypes } from 'devextreme-angular/ui/data-grid';
import { firstValueFrom } from 'rxjs';
import {
  CreatePricingDto,
  UpdatePricingDto,
} from 'src/app/shared/dtos/pricing/pricingDto';
import {
  VisaDiscountRateCreateDto,
  VisaDiscountRateUpdateDto,
} from 'src/app/shared/dtos/visa-discount-rate/VisaDiscountRateDto';
import {
  VisaPriceDefinitionCreateDto,
  VisaPriceDefinitionUpdateDto,
} from 'src/app/shared/dtos/visa-price-definition/visaPriceDefinitionDto';
import {
  VisaLevelCreateDto,
  VisaLevelUpdateDto,
} from 'src/app/shared/dtos/visaLevel/visaLevelDto';
import {
  VisaTypeCreateDto,
  VisaTypeUpdateDto,
} from 'src/app/shared/dtos/visaType/visaTypeDto';
import {
  VisitReasonCreateDto,
  VisitReasonUpdateDto,
} from 'src/app/shared/dtos/visitReason/visitReasonDto';
import { DiscountType } from 'src/app/shared/enums/DiscountType';
import { AgePricingService } from 'src/app/shared/services/agePricing.service';
import { LoadingService } from 'src/app/shared/services/loading.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { PricingCategoryService } from 'src/app/shared/services/pricing-categories.service';
import { PricingService } from 'src/app/shared/services/pricing.service';
import { VisaCountryService } from 'src/app/shared/services/visa-country.service';
import { VisaDiscountRateService } from 'src/app/shared/services/visa-discount-rate.service';
import { VisaLevelService } from 'src/app/shared/services/visa-level.service';
import { VisaTypeService } from 'src/app/shared/services/visa-type.service';
import { VisitReasonService } from 'src/app/shared/services/visit-reason.service';

@Component({
  selector: 'app-discount-definition',
  templateUrl: './discount-definition.component.html',
  styleUrls: ['./discount-definition.component.scss'],
})
export class DiscountDefinitionComponent implements OnInit {
  discountRates: any[] = [];
  visaLevels: any[] = [];
  visaTypes: any[] = [];
  visaPriceDefinitions: any[] = [];
  countries: any[] = [];
  pricings: any[] = [];
  visitReasons: any[] = [];
  pricingCategories: any[] = [];
  discountTypes = [
    { value: DiscountType.Individual, label: 'Bireysel' },
    { value: DiscountType.Family, label: 'Aile' },
  ];

  personCountOptions = [
    { value: 1, label: '1 Kişi' },
    { value: 2, label: '2 Kişi' },
    { value: 3, label: '3 Kişi' },
    { value: 4, label: '4 Kişi' },
    { value: 5, label: '5 Kişi' },
    { value: 6, label: '6 Kişi' },
    { value: 7, label: '7 Kişi' },
    { value: 8, label: '8 Kişi' },
    { value: 8, label: '8 Kişi' },
  ];

  constructor(
    private discountRateService: VisaDiscountRateService,
    private agePricingService: AgePricingService,
    private notificationService: NotificationService,
    private loadingService: LoadingService,
    private pricingService: PricingService,
    private visaLevelService: VisaLevelService,
    private visaTypeService: VisaTypeService,
    private visaCountryService: VisaCountryService,
    private visitReasonService: VisitReasonService,
    private pricingCategoryService: PricingCategoryService
  ) {
    this.getFilteredPersonCountOptions =
      this.getFilteredPersonCountOptions.bind(this);
  }

  ngOnInit(): void {
    this.loadDiscountRates();
    this.loadPricings();
    this.getVisaLevels();
    this.getVisaTypes();
    this.getCountries();
    this.getvisitReasons();
  }

  calculateDiscountRate(rowData: any): number {
    // Backend'den gelen discountRate değerini 100 ile çarpıyoruz
    return rowData.discountRate * 100;
  }

  calculateTotalAmount(rowData: any): number | null {
    // rowData.cost veya rowData.serviceFee null/undefined ise null döndürüyoruz
    if (rowData.cost == null || rowData.serviceFee == null) {
      return null;
    }
    return rowData.cost + rowData.serviceFee;
  }

  loadDiscountRates(): void {
    this.discountRateService.getAll().subscribe((data) => {
      this.discountRates = data;
    });
  }

  async createDiscountRate(event: any): Promise<void> {
    this.loadingService.show();
    try {
      const newRate: VisaDiscountRateCreateDto = event.data;
      await firstValueFrom(this.discountRateService.create(newRate));
      this.notificationService.show(
        'Vize İndirim Tanımı başarıyla kaydedildi.'
      );
      this.notificationService.show(
        'Vize İndirim Tanımı başarıyla kaydedildi.'
      );
    } catch {
    } finally {
      this.loadDiscountRates();
      this.loadingService.hide();
    }
  }

  async updateDiscountRate(event: any): Promise<void> {
    this.loadingService.show();
    try {
      if (event.newData) {
        const updatedRate: VisaDiscountRateUpdateDto = {
          id: event.oldData.id,
          visaPriceDefinitionId:
            event.newData.visaPriceDefinitionId ??
            event.oldData.visaPriceDefinitionId,
          discountType:
            event.newData.discountType ?? event.oldData.discountType,
          numberOfPeople:
            event.newData.numberOfPeople ?? event.oldData.numberOfPeople,
          discountRate:
            event.newData.discountRate ?? event.oldData.discountRate * 100, //arkada tekrar 100e bölmemek için * 100 ile gönderiyoruz
        };

        // Veriyi backend'e gönder
        await firstValueFrom(
          this.discountRateService.update(updatedRate.id, updatedRate)
        );
        this.notificationService.show(
          'Vize İndirim Tanımı başarıyla güncellendi.'
        );
      }
    } catch {
    } finally {
      this.loadDiscountRates();
      this.loadingService.hide(); // Yükleme animasyonunu gizle
    }
  }

  async deleteDiscountRate(event: any): Promise<void> {
    this.loadingService.show();
    try {
      await firstValueFrom(this.discountRateService.delete(event.data.id));
      this.notificationService.show('Vize İndirim Tanımı başarıyla silindi.');
    } catch {
    } finally {
      this.loadDiscountRates();
      this.loadingService.hide();
    }
  }

  setStateValue(
    this: DxDataGridTypes.Column,
    newData: any,
    value: number,
    currentRowData: any
  ) {
    this.defaultSetCellValue?.(newData, value, currentRowData);
  }

  getFilteredPersonCountOptions(options: { data: any }) {
    const discountType = options.data?.discountType;

    if (discountType === 1) {
      return [{ value: 1, label: '1 Kişi' }];
    } else if (discountType === 2) {
      return this.personCountOptions.filter(
        (opt) => opt.value >= 2 && opt.value <= 8
      );
    } else if (discountType === 2) {
      return this.personCountOptions.filter(
        (opt) => opt.value >= 2 && opt.value <= 8
      );
    }
    return this.personCountOptions;
  }

  onEditorPreparing(e: DxDataGridTypes.EditorPreparingEvent<any>) {
    if (e.parentType === 'dataRow' && e.dataField === 'numberOfPeople') {
      if (e.row?.data.discountType === DiscountType.Individual) {
        // e.editorOptions.value = 1;
      }
      if (e.row?.data.discountType === DiscountType.Individual) {
        // e.editorOptions.value = 1;
      }
    }
  }

  loadPricings(): void {
    this.pricingService.getList().subscribe((data) => {
      this.pricings = data;
    });
  }

  async createPricing(event: any): Promise<void> {
    this.loadingService.show();
    try {
      const newPricing: CreatePricingDto = event.data;
      await firstValueFrom(this.pricingService.create(newPricing));
      this.notificationService.show('Fiyatlandırma başarıyla kaydedildi.');
    } catch {
    } finally {
      this.loadPricings();
      this.loadingService.hide();
    }
  }

  async updatePricing(event: any): Promise<void> {
    this.loadingService.show();
    try {
      if (event.newData) {
        const updatedPricing: UpdatePricingDto = {
          id: event.oldData.id,
          name: event.newData.name ?? event.oldData.name,
          description: event.newData.description ?? event.oldData.description,
          cost: event.newData.cost ?? event.oldData.cost,
          saleAmount: event.newData.saleAmount ?? event.oldData.saleAmount,
          pricingCategoryId:
            event.newData.pricingCategoryId ?? event.oldData.pricingCategoryId,
        };

        // Veriyi backend'e gönder
        await firstValueFrom(
          this.pricingService.update(updatedPricing.id, updatedPricing)
        );
        await firstValueFrom(
          this.pricingService.update(updatedPricing.id, updatedPricing)
        );

        this.notificationService.show('Fiyatlandırma başarıyla güncellendi.');
      }
    } catch {
    } finally {
      this.loadPricings();
      this.loadingService.hide(); // Yükleme animasyonunu gizle
    }
  }

  async deletePricing(event: any): Promise<void> {
    this.loadingService.show();
    try {
      await firstValueFrom(this.discountRateService.delete(event.data.id));
      this.notificationService.show('Fiyatlandırma başarıyla silindi.');
    } catch {
    } finally {
      this.loadPricings();
      this.loadingService.hide();
    }
  }
  generateCost(rowData: any): string {
    if (rowData.cost == null || rowData.cost == 0) {
      return '';
    }
    return rowData.cost + ' $';
  }

  generateSaleAmount(rowData: any): string {
    if (rowData.saleAmount == null || rowData.saleAmount == 0) {
      return '';
    }
    return rowData.saleAmount + ' $';
  }
  generateCostUnder18(rowData: any): string {
    if (rowData.cost_Under18 == null || rowData.cost_Under18 == 0) {
      return '';
    }
    return rowData.cost_Under18 + ' $';
  }
  generateSaleAmountUnder18(rowData: any): string {
    if (rowData.saleAmount_Under18 == null || rowData.saleAmount_Under18 == 0) {
      return '';
    }
    return rowData.saleAmount_Under18 + ' $';
  }

  // Visa Type CRUD
  async createVisaType(event: any) {
    this.loadingService.show();
    const visaTypeCreateDto: VisaTypeCreateDto = {
      name: event.data.name,
      description: event.data.description,
      visaCountryId: event.data.visaCountryId,
      saleAmount: event.data.saleAmount,
      saleAmount_Under18: event.data.saleAmount_Under18,
      cost_Under18: event.data.cost_Under18,
      cost: event.data.cost,
      isActive: event.data.isActive,
    };
    await firstValueFrom(this.visaTypeService.create(visaTypeCreateDto));
    this.getVisaTypes();
    this.notificationService.show('Vize Türü başarıyla kaydedildi.');
    this.loadingService.hide();
  }

  async updateVisaType(event: any) {
    this.loadingService.show();
    if (event.newData) {
      const visaTypeUpdateDto: VisaTypeUpdateDto = {
        id: event.oldData.id,
        name: event.newData.name ?? event.oldData.name,
        description: event.newData.description ?? event.oldData.description,
        visaCountryId:
          event.newData.visaCountryId ?? event.oldData.visaCountryId,
        saleAmount: event.newData.saleAmount ?? event.oldData.saleAmount,
        saleAmount_Under18:
          event.newData.saleAmount_Under18 ?? event.oldData.saleAmount_Under18,
        cost_Under18: event.newData.cost_Under18 ?? event.oldData.cost_Under18,
        cost: event.newData.cost ?? event.oldData.cost,
        isActive: event.newData.isActive ?? event.oldData.isActive,
      };
      await firstValueFrom(
        this.visaTypeService.update(visaTypeUpdateDto.id, visaTypeUpdateDto)
      );
      this.getVisaTypes();
      this.notificationService.show('Vize Türü başarıyla güncellendi.');
    }
    this.loadingService.hide();
  }

  async deleteVisaType(event: any) {
    this.loadingService.show();
    await firstValueFrom(this.visaTypeService.delete(event.key));
    this.getVisaTypes();
    this.notificationService.show('Vize Türü başarıyla silindi.');
    this.loadingService.hide();
  }

  // Fetch Data for Grids
  getCountries() {
    this.visaCountryService.getAll().subscribe((data: any[]) => {
      this.countries = data;
    });
  }

  getVisaTypes() {
    this.visaTypeService.getList().subscribe((data: any[]) => {
      this.visaTypes = data;
    });
  }

  // Visa Level CRUD

  async createVisaLevel(event: any) {
    this.loadingService.show();
    try {
      const visaLevelCreateDto: VisaLevelCreateDto = {
        name: event.data.name,
        description: event.data.description,
        visaCountryId: event.data.visaCountryId,
        saleAmount: event.data.saleAmount,

        cost: event.data.cost,
        isActive: event.data.isActive,
      };
      await firstValueFrom(this.visaLevelService.create(visaLevelCreateDto));
      this.notificationService.show('Vize Aciliyeti başarıyla kaydedildi.');
    } catch {
    } finally {
      this.getVisaLevels();
      this.loadingService.hide();
    }
  }

  async updateVisaLevel(event: any) {
    this.loadingService.show();
    console.log(event.newData);
    try {
      if (event.newData) {
        const visaLevelUpdateDto: VisaLevelUpdateDto = {
          id: event.oldData.id,
          name: event.newData.name ?? event.oldData.name,
          description: event.newData.description ?? event.oldData.description,
          visaCountryId:
            event.newData.visaCountryId ?? event.oldData.visaCountryId,
          saleAmount: event.newData.saleAmount ?? event.oldData.saleAmount,

          cost: event.newData.cost ?? event.oldData.cost,

          isActive: event.newData.isActive ?? event.oldData.isActive,
        };
        await firstValueFrom(
          this.visaLevelService.update(
            visaLevelUpdateDto.id,
            visaLevelUpdateDto
          )
        );
        this.notificationService.show('Vize Aciliyeti başarıyla güncellendi.');
      }
    } catch {
    } finally {
      this.getVisaLevels();
      this.loadingService.hide();
    }
  }

  async deleteVisaLevel(event: any) {
    this.loadingService.show();
    try {
      await firstValueFrom(this.visaLevelService.delete(event.key));
      this.notificationService.show('Vize Aciliyeti başarıyla silindi.');
    } catch {
    } finally {
      this.getVisaLevels();
      this.loadingService.hide();
    }
  }

  onInitNewRow(event: any): void {
    event.data.isActive = true;
  }

  getVisaLevels() {
    this.visaLevelService.getList().subscribe((data: any[]) => {
      this.visaLevels = data; // VisaLevel veri dizisine atama
      this.visaLevels = data; // VisaLevel veri dizisine atama
    });
  }

  async createVisitReason(event: any) {
    this.loadingService.show();
    try {
      const visitReasonCreateDto: VisitReasonCreateDto = {
        name: event.data.name,
        description: event.data.description,
        visaCountryId: event.data.visaCountryId,
        saleAmount: event.data.saleAmount ?? 0,
        cost: event.data.cost ?? 0,
        isActive: event.data.isActive,
      };
      await firstValueFrom(
        this.visitReasonService.create(visitReasonCreateDto)
      );
      await firstValueFrom(
        this.visitReasonService.create(visitReasonCreateDto)
      );
      this.notificationService.show('Ziyaret Sebebi başarıyla kaydedildi.');
    } catch {
    } finally {
      this.getvisitReasons();
      this.loadingService.hide();
    }
  }

  // Visa Reason Update işlemi
  async updateVisitReason(event: any) {
    this.loadingService.show();
    try {
      if (event.newData) {
        const visitReasonUpdateDto: VisitReasonUpdateDto = {
          id: event.oldData.id,
          name: event.newData.name ?? event.oldData.name,
          description: event.newData.description ?? event.oldData.description,
          visaCountryId:
            event.newData.visaCountryId ?? event.oldData.visaCountryId,
          saleAmount: event.newData.saleAmount ?? event.oldData.saleAmount,
          cost: event.newData.cost ?? event.oldData.cost,
          isActive: event.newData.isActive ?? event.oldData.isActive,
        };
        await firstValueFrom(
          this.visitReasonService.update(
            visitReasonUpdateDto.id,
            visitReasonUpdateDto
          )
        );
        await firstValueFrom(
          this.visitReasonService.update(
            visitReasonUpdateDto.id,
            visitReasonUpdateDto
          )
        );
        this.notificationService.show('Ziyaret Sebebi başarıyla güncellendi.');
      }
    } catch {
    } finally {
      this.getvisitReasons();
      this.loadingService.hide();
    }
  }

  async deleteVisitReason(event: any) {
    this.loadingService.show();
    try {
      await firstValueFrom(this.visitReasonService.delete(event.key));
      this.notificationService.show('Ziyaret Sebebi başarıyla silindi.');
    } catch {
    } finally {
      this.getvisitReasons();
      this.loadingService.hide();
    }
  }

  getvisitReasons() {
    this.visitReasonService.getAll().subscribe((data: any[]) => {
      this.visitReasons = data; // visitReason veri dizisine atama
      this.visitReasons = data; // visitReason veri dizisine atama
    });
  }
}
